import React from 'react'
import { TextStyled } from '..';

const Marked = ({
  children,
  size,
  weight,
  color,
  align,
  as,
}) => {

  const firstMarkItem = children?.find(item => item?.includes('(*)'))
  const firstMarkIdx = firstMarkItem?.match(/\([*]\)/).index
  const startsWithMark = firstMarkIdx === 0

  const newText = []

  children.forEach(item => {
    if (typeof item === 'string') {
      const txts = item.split(/\(\/?[*]\)/).filter(n => n)
      newText.push(...txts)

    } else {
      newText.push(item)
    }
  })


  return (
    <TextStyled
      size={size}
      weight={weight}
      color={color}
      align={align}
      as={as}
    >

      {newText.map((txt, idx) => {
        const isEven = idx % 2 === 0

        const isMarked = (startsWithMark && isEven)
          || (!startsWithMark && !isEven)


        return (
          <TextStyled
            size={size}
            weight={weight}
            color={isMarked ? 'highlight' : color}
            align={align}
            as={'span'}
            key={txt}
          >
            {txt}
          </TextStyled>
        )
      })}
    </TextStyled>
  )
}

export default Marked